// extracted by mini-css-extract-plugin
export default {"viewButton":"ggnRNiR3a0em59ijAlWb6Q=="};